import PropTypes from 'prop-types';

export default PropTypes.shape({
  value: PropTypes.string,
  label: PropTypes.node
});



// WEBPACK FOOTER //
// ./src/types/CheckboxFieldItem.js